<div class="container py-4">
  <h2>Dashboard</h2>
  <div class="col-12 d-flex justify-content-end mb-1">
    <select class="form-select w-auto" [(ngModel)]="selectedZone" (change)="onZoneChange($event)">
      <option value="school">School</option>
      <option value="teacher">Teacher</option>
      <option value="loginLogout">Login/Logout</option>
    </select>
  </div>
  @if(selectedZone === 'school') {

  <div class="row g-4">
    @for (item of schoolMenuItems; track item) {
    <div class="col-md-3">
      <a (click)="setRouter(item)" class="text-decoration-none">
        <div class="storage-card" [ngStyle]="{'border-top': '4px solid ' + item.color}"
          [ngClass]="{'disabledCards': !item.route}">
          <div class="icon" [ngStyle]="{'color': item.color}">
            <i [class]="item.icon"></i>
          </div>
          <h5 class="title">{{ item.value }}</h5>
        </div>
      </a>
    </div>
    }
  </div>
  }@else if(selectedZone === 'teacher') {
  <div class="row g-4">
    @for (item of teacherMenuItems; track item) {
    <div class="col-md-3">
      <a (click)="setRouter(item)" class="text-decoration-none">
        <div class="storage-card" [ngStyle]="{'border-top': '4px solid ' + item.color}"
          [ngClass]="{'disabledCards': !item.route}">
          <div class="icon" [ngStyle]="{'color': item.color}">
            <i [class]="item.icon"></i>
          </div>
          <h5 class="title">{{ item.value }}</h5>
        </div>
      </a>
    </div>
    }
  </div>
  }